import { useStore } from 'vuex'
import { defNotifyDuration } from '@/data/globals.js'

export default function useNotify () {
    const store = useStore()

    // Важно! Для React:
    // При использовании setTimeout фильтруем notifyRef.current, а не notifyList. Поскольку при добавлении элементов в массив notifyList и запуске удаления через setTimeout, состояение notifyList не изменится к моменту запуска delNotify по таймеру. В такой ситуации используем useRef (см. 2 строки ниже) и фильтруем notifyRef.current с актуальными данными
    // const notifyRef = useRef(notifyList);
    // notifyRef.current = notifyList;

    // Удаление уведомления
    function delNotify(id) {
        store.commit('DelNotify', id)
    }
    
    // Добавление уведомления
    function pushNotify(
        notifyText = "Default Notification Text", // текст уведомления (можно html)
        notifyClass = "notifyBlue", // цвета (стиль) уведомления
        notifyDuration = defNotifyDuration // продолжительность показа уведомления (в мс)
    ){
        let id = Date.now() // генерация уникального id
        // 1. Добавляем уведомление в массив
        let newNotify = { id: id, notifyText: notifyText, class: notifyClass }
        store.commit('AddNotify', newNotify)
        // 2. Удаляем через некоторое время
        setTimeout(()=>{
            store.commit('DelNotify', id)
        }, notifyDuration)
    }

    return { delNotify, pushNotify }
}